var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDimensions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100.000000pt",
    height: "100.000000pt",
    viewBox: "0 0 100.000000 100.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,100.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75 940 l-60 -60 63 -62 c48 -49 64 -60 74 -50 9 9 4 21 -27 52 l-39 40 264 0 264 0 -39 -40 c-31 -31 -36 -43 -27 -52 10 -10 26 1 75 50 l62 62 -62 62 c-49 49 -65 60 -75 50 -9 -9 -4 -21 27 -52 l39 -40 -264 0 -264 0 38 39 c33 34 41 61 18 61 -4 0 -34 -27 -67 -60z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 350 l0 -350 350 0 350 0 0 350 0 350 -350 0 -350 0 0 -350z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815 620 c-46 -47 -57 -62 -47 -72 9 -9 21 -4 52 27 l40 39 0 -264 0 -264 -40 39 c-31 31 -43 36 -52 27 -10 -10 1 -26 50 -75 l62 -62 62 62 c49 49 60 65 50 75 -9 9 -21 4 -52 -27 l-40 -39 0 264 0 264 40 -39 c31 -31 43 -36 52 -27 10 10 -1 25 -47 72 -33 33 -62 60 -65 60 -3 0 -32 -27 -65 -60z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDimensions);
export default __webpack_public_path__ + "static/media/dimensions.7320ceb7.svg";
export { ForwardRef as ReactComponent };